import { inject, Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class QueryParameterService {
  private readonly router = inject(Router);

  /**
   * Stores params in sessionStorage merged with any previously stored params, then navigates to them.
   */
  setQueryParams({
    key,
    queryParams,
    mergeWithExisting = true,
  }: {
    key: string;
    queryParams: Params;
    mergeWithExisting?: boolean;
  }): Promise<boolean> {
    const newParams = { ...this.readStoredParams(key), ...queryParams };
    sessionStorage.setItem(key, JSON.stringify(newParams));

    return this.router
      .navigate([], { queryParams: newParams, queryParamsHandling: mergeWithExisting ? 'merge' : undefined })
      .catch(() => false);
  }

  reset(key: string): Promise<boolean> {
    sessionStorage.removeItem(key);

    return this.router.navigate([], { queryParams: {} }).catch(() => false);
  }

  private readStoredParams(key: string): Params {
    try {
      return JSON.parse(sessionStorage.getItem(key) ?? '{}') as Params;
    } catch {
      return {};
    }
  }
}
